// Known portal apex domains — only treat parts[0] as a slug when the rest of
// the hostname matches one of these. Prevents www/staging/IP mismatches and
// keeps custom-domain handling (INB-4409) out of this function entirely.
const PORTAL_APEXES = new Set([
  'helpscoutportal.com',
  'portal-np.superscout.net',
  'portal.local.hsenv.io',
])

// Resolution order:
// 1. First subdomain of a known portal apex — acme.helpscoutportal.com → "acme"
// 2. ?slug= query param — local dev / Cloudflare preview fallback (captured once
//    at mount by TenantProvider so it persists through React Router navigation)
export const resolveTenantSlug = (): string | null => {
  const parts = window.location.hostname.split('.')
  if (parts.length >= 3 && PORTAL_APEXES.has(parts.slice(1).join('.')))
    return parts[0]

  return new URLSearchParams(window.location.search).get('slug')
}
